<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbs" />
    <b-container fluid>
      <!-- Tab -->
      <b-row>
        <b-col lg="12">
          <b-tabs pills justified class="navtab-bg">
            <b-tab active title="Maintenance Board">
              <!-- Top Section !-->
              <b-row>
                <b-col lg="12">
                  <b-card>
                    <b-card-title>
                      <div class="row">
                        <div class="col-md-10">
                          <h4 class="card-title text-primary"
                            ><strong>Filter Maintenance Board</strong></h4
                          >
                        </div>
                        <div class="col-md-2 float-right">
                          <a
                            class="text-primary float-right"
                            v-b-toggle.collapse-filter
                            role="button"
                            style="cursor: pointer"
                          >
                            <i class="fa fa-filter" />
                          </a>
                        </div>
                      </div>
                    </b-card-title>
                    <b-card-body>
                      <b-collapse id="collapse-filter" visible>
                        <b-row>
                          <b-col md="4">
                            <b-form-group
                              label="Category:"
                              label-for="kind-fleet"
                            >
                              <template v-for="(item, index) in vehicle">
                                <b-form-checkbox
                                  v-model="item.checked"
                                  :disabled="item.disabled"
                                  name="check-button"
                                  switch
                                  inline
                                  :key="index"
                                >
                                  {{ item.label }}
                                </b-form-checkbox>
                              </template>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-form-group
                              label="Fleet/Equipment:"
                              label-for="fleet-equipment"
                            >
                              <v-multiselect
                                v-model="selectedFleetEquipment"
                                tag-placeholder="Category"
                                placeholder="Search or add a category"
                                label="name"
                                track-by="code"
                                :options="fleetEquipmentList"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                              >
                              </v-multiselect>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-form-group
                              label="Date Range:"
                              label-for="Date Range"
                            >
                              <date-picker
                                :lang="lang"
                                v-model="dateRange"
                                type="date"
                                range
                                placeholder="Select date range"
                              ></date-picker>
                            </b-form-group>
                          </b-col>
                          <b-col md="2">
                            <b-form-group
                              label="Filter"
                              label-for="button_search"
                            >
                              <b-button variant="primary" class="mb-3 mr-1"
                                ><i class="fa fa-filter"></i
                              ></b-button>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <!-- End Top Section !-->
              <!-- Content Section !-->
              <b-row>
                <b-col lg="12">
                  <b-card body-class="p-0">
                    <b-card-body>
                      <b-tabs pills justified class="navtab-tag">
                        <b-tab active title="Task List">
                          <div class="row">
                            <b-col sm="12">
                              <b-row>
                                <b-col md="4">
                                  <b-card
                                    text-variant="white"
                                    bg-variant="danger"
                                    class="iq-mb-3"
                                  >
                                    <b-card-title class="text-white text-center"
                                      ><h1 class="text-white">60</h1></b-card-title
                                    >
                                    <blockquote class="blockquote mb-0 text-center">
                                      <p class="font-size-22"
                                        ><strong>Overdue</strong></p
                                      >
                                    </blockquote>
                                  </b-card>
                                </b-col>
                                <b-col md="4">
                                  <b-card
                                    text-variant="white"
                                    bg-variant="warning"
                                    class="iq-mb-3"
                                  >
                                    <b-card-title class="text-white text-center"
                                      ><h1 class="text-white">20</h1></b-card-title
                                    >
                                    <blockquote class="blockquote mb-0 text-center">
                                      <p class="font-size-22"
                                        ><strong>Postponed</strong></p
                                      >
                                    </blockquote>
                                  </b-card>
                                </b-col>
                                <b-col md="4">
                                  <b-card
                                    text-variant="white"
                                    bg-variant="primary"
                                    class="iq-mb-3"
                                  >
                                    <b-card-title class="text-white text-center"
                                      ><h1 class="text-white">8</h1></b-card-title
                                    >
                                    <blockquote class="blockquote mb-0 text-center">
                                      <p class="font-size-22"
                                        ><strong
                                          >Next Jobs Based on Running Hours</strong
                                        ></p
                                      >
                                    </blockquote>
                                  </b-card>
                                </b-col>
                                <b-col md="3">
                                  <iq-card
                                    class-name="iq-card-block iq-card-stretch"
                                  >
                                    <template v-slot:body>
                                      <div
                                        class="
                                          d-flex
                                          align-items-center
                                          justify-content-between
                                        "
                                      >
                                        <div class="text-left">
                                          <h5
                                            class="
                                              card-title
                                              mb-2
                                              mt-2
                                              text-primary
                                            "
                                            ><strong>Next 1 Month</strong></h5
                                          >
                                          <h3 class="mb-0 line-height">12</h3>
                                        </div>
                                        <div
                                          class="
                                            rounded-circle
                                            iq-card-icon
                                            bg-warning
                                          "
                                          ><i class="fa fa-clock"></i
                                        ></div>
                                      </div>
                                    </template>
                                  </iq-card>
                                </b-col>
                                <b-col md="3">
                                  <iq-card
                                    class-name="iq-card-block iq-card-stretch"
                                  >
                                    <template v-slot:body>
                                      <div
                                        class="
                                          d-flex
                                          align-items-center
                                          justify-content-between
                                        "
                                      >
                                        <div class="text-left">
                                          <h5
                                            class="
                                              card-title
                                              mb-2
                                              mt-2
                                              text-primary
                                            "
                                            ><strong>Next 3 Month</strong></h5
                                          >
                                          <h3 class="mb-0 line-height">8</h3>
                                        </div>
                                        <div
                                          class="
                                            rounded-circle
                                            iq-card-icon
                                            bg-warning
                                          "
                                          ><i class="fa fa-calendar-week"></i
                                        ></div>
                                      </div>
                                    </template>
                                  </iq-card>
                                </b-col>
                                <b-col md="3">
                                  <iq-card
                                    class-name="iq-card-block iq-card-stretch"
                                  >
                                    <template v-slot:body>
                                      <div
                                        class="
                                          d-flex
                                          align-items-center
                                          justify-content-between
                                        "
                                      >
                                        <div class="text-left">
                                          <h5
                                            class="
                                              card-title
                                              mb-2
                                              mt-2
                                              text-primary
                                            "
                                            ><strong>Next 6 Month</strong></h5
                                          >
                                          <h3 class="mb-0 line-height">8</h3>
                                        </div>
                                        <div
                                          class="
                                            rounded-circle
                                            iq-card-icon
                                            bg-primary
                                          "
                                          ><i class="fa fa-calendar-alt"></i
                                        ></div>
                                      </div>
                                    </template>
                                  </iq-card>
                                </b-col>
                                <b-col md="3">
                                  <iq-card
                                    class-name="iq-card-block iq-card-stretch"
                                  >
                                    <template v-slot:body>
                                      <div
                                        class="
                                          d-flex
                                          align-items-center
                                          justify-content-between
                                        "
                                      >
                                        <div class="text-left">
                                          <h5
                                            class="
                                              card-title
                                              mb-2
                                              mt-2
                                              text-primary
                                            "
                                            ><strong>Next 12 Month</strong></h5
                                          >
                                          <h3 class="mb-0 line-height">8</h3>
                                        </div>
                                        <div
                                          class="
                                            rounded-circle
                                            iq-card-icon
                                            bg-success
                                          "
                                          ><i class="fa fa-calendar"></i
                                        ></div>
                                      </div>
                                    </template>
                                  </iq-card>
                                </b-col>
                              </b-row>
                            </b-col>
                            <!-- Detail Job -->
                            <b-col sm="12">
                              <iq-card class-name="iq-card-block iq-card-stretch">
                                <template v-slot:body>
                                  <b-tabs>
                                    <b-tab
                                      active
                                      title="Overdue Jobs">
                                      <div class="table-responsive">
                                        <table
                                          class="
                                            table
                                            mb-0
                                            table-striped table-hover
                                          "
                                        >
                                          <thead class="text-center">
                                            <tr>
                                              <td>No</td>
                                              <td>Fleet/Equipment</td>
                                              <td>Job Name</td>
                                              <td>Component Name</td>
                                              <td>Frequency</td>
                                              <td>Last Maintenance</td>
                                              <td>Due Date / Hours</td>
                                              <td>Current</td>
                                              <td>Status</td>
                                              <td>Action</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="(job, index) in jobs">
                                              <tr :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ job.fleet }}</td>
                                                <td>{{ job.jobName }}</td>
                                                <td>{{ job.componentName }}</td>
                                                <td>{{ job.frequency }}</td>
                                                <td>{{ job.lastMaintenance }}</td>
                                                <td
                                                  ><span>{{ job.dueDate }}</span
                                                  ><div
                                                    v-if="
                                                      job.pendingDate === null ||
                                                      job.pendingDate === '' ||
                                                      job.pendingDate === undefined
                                                    "
                                                  ></div>
                                                  <div v-else
                                                    ><small
                                                      >Last Due #1 :
                                                      {{ job.pendingDate }}</small
                                                    ></div
                                                  ></td
                                                >
                                                <td>{{ job.current }}</td>
                                                <td
                                                  ><b-badge variant="danger">{{
                                                    job.status
                                                  }}</b-badge></td
                                                >
                                                <td>
                                                  <b-dropdown
                                                    variant="success"
                                                    text=""
                                                  >
                                                    <b-dropdown-item
                                                      href="#"
                                                      v-b-modal="
                                                        'maintenance' + index
                                                      "
                                                      variant="primary"
                                                      ><i class="las la-tasks"></i>
                                                      Maintenance</b-dropdown-item
                                                    >
                                                    <b-modal
                                                      :id="'maintenance' + index"
                                                      size="lg"
                                                      title="Maintenance Action"
                                                    >
                                                      <fieldset
                                                        class="
                                                          form-group
                                                          border
                                                          p-3
                                                        "
                                                      >
                                                        <legend class="w-auto px-2"
                                                          >Overview:</legend
                                                        >
                                                        <b-row>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Fleet"
                                                              label-for="serial"
                                                            >
                                                              TB.ETI 101
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Job Name"
                                                              label-for="serial"
                                                            >
                                                              10.000 H Maintenance
                                                              Job
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Type"
                                                              label-for="type"
                                                            >
                                                              Non Machinery
                                                              Equipment
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Category Equipment"
                                                              label-for="serial"
                                                            >
                                                              Hull & Load Line
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Component No"
                                                              label-for="serial"
                                                            >
                                                              300011
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Component Name"
                                                              label-for="serial"
                                                            >
                                                              Load Line
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Trigger"
                                                              label-for="serial"
                                                            >
                                                              Calendar Trigger
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Frequency"
                                                              label-for="serial"
                                                            >
                                                              3 Months
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="12">
                                                            <b-form-group
                                                              label="Standard Job Description"
                                                              label-for="serial"
                                                            >
                                                              - Check anything you
                                                              need
                                                            </b-form-group>
                                                          </b-col>
                                                        </b-row>
                                                      </fieldset>
                                                      <fieldset
                                                        class="
                                                          form-group
                                                          border
                                                          p-3
                                                        "
                                                      >
                                                        <legend class="w-auto px-2"
                                                          >Maintenance:</legend
                                                        >
                                                        <b-row>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Start Date:"
                                                              label-for="startDate"
                                                            >
                                                              <b-form-input
                                                                type="date"
                                                                value="2019-12-19"
                                                              ></b-form-input>
                                                              <small
                                                                style="float: right"
                                                                >click
                                                                <i
                                                                  class="
                                                                    fa fa-calendar
                                                                  "
                                                                ></i>
                                                                to show</small
                                                              >
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="End Date:"
                                                              label-for="endDate"
                                                            >
                                                              <b-form-input
                                                                type="date"
                                                                value="2019-12-19"
                                                              ></b-form-input>
                                                              <small
                                                                style="float: right"
                                                                >click
                                                                <i
                                                                  class="
                                                                    fa fa-calendar
                                                                  "
                                                                ></i>
                                                                to show</small
                                                              >
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Cost:"
                                                              label-for="cost"
                                                            >
                                                              <b-input-group
                                                                size="md"
                                                                prepend="Rp"
                                                              >
                                                                <b-form-input
                                                                  type="number"
                                                                ></b-form-input>
                                                              </b-input-group>
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label-for="maintenanceFile"
                                                              label="File Maintenance"
                                                            >
                                                              <b-form-file
                                                                placeholder="Choose a file"
                                                                id="customFile"
                                                              ></b-form-file>
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="12">
                                                            <b-form-group
                                                              label-for="Notes"
                                                              label="Notes"
                                                            >
                                                              <b-form-textarea
                                                                id="notes"
                                                                rows="3"
                                                                placeholder="Type Notes"
                                                              ></b-form-textarea>
                                                            </b-form-group>
                                                          </b-col>
                                                        </b-row>
                                                      </fieldset>
                                                    </b-modal>
                                                    <b-dropdown-item
                                                      href="#"
                                                      variant="danger"
                                                      ><i class="las la-anchor"></i>
                                                      Convert Service &
                                                      Repair</b-dropdown-item
                                                    >
                                                    <b-dropdown-item
                                                      href="#"
                                                      v-b-modal="
                                                        'postponed' + index
                                                      "
                                                      variant="warning"
                                                      ><i
                                                        class="las la-calendar"
                                                      ></i>
                                                      Postpone</b-dropdown-item
                                                    >
                                                    <b-modal
                                                      :id="'postponed' + index"
                                                      size="lg"
                                                      title="Postponed"
                                                    >
                                                      <fieldset
                                                        class="
                                                          form-group
                                                          border
                                                          p-3
                                                        "
                                                      >
                                                        <legend class="w-auto px-2"
                                                          >Overview:</legend
                                                        >
                                                        <b-row>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Fleet"
                                                              label-for="serial"
                                                            >
                                                              TB.ETI 101
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Job Name"
                                                              label-for="serial"
                                                            >
                                                              10.000 H Maintenance
                                                              Job
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Type"
                                                              label-for="type"
                                                            >
                                                              Non Machinery
                                                              Equipment
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Category Equipment"
                                                              label-for="serial"
                                                            >
                                                              Hull & Load Line
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Component No"
                                                              label-for="serial"
                                                            >
                                                              300011
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Component Name"
                                                              label-for="serial"
                                                            >
                                                              Load Line
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Trigger"
                                                              label-for="serial"
                                                            >
                                                              Calendar Trigger
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Frequency"
                                                              label-for="serial"
                                                            >
                                                              3 Months
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="12">
                                                            <b-form-group
                                                              label="Standard Job Description"
                                                              label-for="serial"
                                                            >
                                                              - Check anything you
                                                              need
                                                            </b-form-group>
                                                          </b-col>
                                                        </b-row>
                                                      </fieldset>
                                                      <fieldset
                                                        class="
                                                          form-group
                                                          border
                                                          p-3
                                                        "
                                                      >
                                                        <legend class="w-auto px-2"
                                                          >Postponed:</legend
                                                        >
                                                        <b-row>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Last Maintenance"
                                                              label-for="serial"
                                                            >
                                                              5 Oktober 2020
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="6">
                                                            <b-form-group
                                                              label="Due Date"
                                                              label-for="serial"
                                                            >
                                                              20 Maret 2021
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="2"></b-col>
                                                          <b-col md="8">
                                                            <b-form-group
                                                              label="New Due Date"
                                                              label-for="serial"
                                                            >
                                                              <b-form-input
                                                                type="date"
                                                                value="2019-12-19"
                                                              ></b-form-input>
                                                              <small
                                                                style="float: right"
                                                                >click
                                                                <i
                                                                  class="
                                                                    fa fa-calendar
                                                                  "
                                                                ></i>
                                                                to show</small
                                                              >
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="2"></b-col>
                                                          <b-col md="2"></b-col>
                                                          <b-col md="8">
                                                            <b-form-group
                                                              label="Postponed Reason"
                                                              label-for="serial"
                                                            >
                                                              <b-form-textarea
                                                                id="description"
                                                                rows="3"
                                                                placeholder="Type Reason"
                                                              ></b-form-textarea>
                                                            </b-form-group>
                                                          </b-col>
                                                          <b-col md="2"></b-col>
                                                        </b-row>
                                                      </fieldset>
                                                    </b-modal>
                                                  </b-dropdown>
                                                </td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-tab>

                                    <b-tab title="Postponed Jobs">
                                      <div class="table-responsive">
                                        <table
                                          class="
                                            table
                                            mb-0
                                            table-striped table-hover
                                          "
                                        >
                                          <thead class="text-center">
                                            <tr>
                                              <td>No</td>
                                              <td>Fleet/Equipment</td>
                                              <td>Job Name</td>
                                              <td>Component Name</td>
                                              <td>Frequency</td>
                                              <td>Last Maintenance</td>
                                              <td>Due Date / Hours</td>
                                              <td>Current</td>
                                              <td>Reason</td>
                                              <td>Action</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="(job, index) in jobs">
                                              <tr :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ job.fleet }}</td>
                                                <td>{{ job.jobName }}</td>
                                                <td>{{ job.componentName }}</td>
                                                <td>{{ job.frequency }}</td>
                                                <td>{{ job.lastMaintenance }}</td>
                                                <td
                                                  ><span>{{ job.dueDate }}</span
                                                  ><div
                                                    v-if="
                                                      job.pendingDate === null ||
                                                      job.pendingDate === '' ||
                                                      job.pendingDate === undefined
                                                    "
                                                  ></div>
                                                  <div v-else
                                                    ><small
                                                      >last Due #1 :
                                                      {{ job.pendingDate }}</small
                                                    ></div
                                                  ></td
                                                >
                                                <td>{{ job.current }}</td>
                                                <td>{{ job.reason }}</td>
                                                <td>
                                                  <b-dropdown
                                                    variant="success"
                                                    text=""
                                                  >
                                                    <b-dropdown-item
                                                      href="#"
                                                      variant="primary"
                                                      ><i class="las la-tasks"></i>
                                                      Maintenance</b-dropdown-item
                                                    >
                                                  </b-dropdown>
                                                </td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-tab>

                                    <b-tab title="Next Jobs Based on Running Hours">
                                      <div class="table-responsive">
                                        <table
                                          class="
                                            table
                                            mb-0
                                            table-striped table-hover
                                          "
                                        >
                                          <thead class="text-center">
                                            <tr>
                                              <td>No</td>
                                              <td>Fleet/Equipment</td>
                                              <td>Job Name</td>
                                              <td>Component Name</td>
                                              <td>Frequency</td>
                                              <td>Last Maintenance</td>
                                              <td>Last Running Maintenance</td>
                                              <td>Current Running Hours</td>
                                              <td>Next Running Hours</td>
                                              <td>Status</td>
                                              <td>Action</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template
                                              v-for="(job, index) in jobsHours"
                                            >
                                              <tr :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ job.fleet }}</td>
                                                <td>{{ job.jobName }}</td>
                                                <td>{{ job.componentName }}</td>
                                                <td>{{ job.frequency }}</td>
                                                <td>{{ job.lastMaintenance }}</td>
                                                <td>{{
                                                  job.lastRunningMaintenance
                                                }}</td>
                                                <td>{{ job.current }}</td>
                                                <td>{{ job.nextRunningHours }}</td>
                                                <td>{{ job.status }}</td>
                                                <b-dropdown
                                                  variant="success"
                                                  text=""
                                                >
                                                  <b-dropdown-item
                                                    href="#"
                                                    variant="primary"
                                                    ><i class="las la-tasks"></i>
                                                    Maintenance</b-dropdown-item
                                                  >
                                                </b-dropdown>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-tab>

                                    <b-tab title="Next Jobs 1 Month">
                                      <div class="table-responsive">
                                        <table
                                          class="
                                            table
                                            mb-0
                                            table-striped table-hover
                                          "
                                        >
                                          <thead class="text-center">
                                            <tr>
                                              <td>No</td>
                                              <td>Fleet/Equipment</td>
                                              <td>Job Name</td>
                                              <td>Component Name</td>
                                              <td>Frequency</td>
                                              <td>Last Maintenance</td>
                                              <td>Due Date</td>
                                              <td>Current</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="(job, index) in jobs">
                                              <tr :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ job.fleet }}</td>
                                                <td>{{ job.jobName }}</td>
                                                <td>{{ job.componentName }}</td>
                                                <td>{{ job.frequency }}</td>
                                                <td>{{ job.lastMaintenance }}</td>
                                                <td
                                                  ><span>{{ job.dueDate }}</span
                                                  ><div
                                                    v-if="
                                                      job.pendingDate === null ||
                                                      job.pendingDate === '' ||
                                                      job.pendingDate === undefined
                                                    "
                                                  ></div>
                                                  <div v-else
                                                    ><small
                                                      >Last Due #1 :
                                                      {{ job.pendingDate }}</small
                                                    ></div
                                                  ></td
                                                >
                                                <td>{{ job.current }}</td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-tab>

                                    <b-tab title="Next Jobs 3 Month">
                                      <div class="table-responsive">
                                        <table
                                          class="
                                            table
                                            mb-0
                                            table-striped table-hover
                                          "
                                        >
                                          <thead class="text-center">
                                            <tr>
                                              <td>No</td>
                                              <td>Fleet/Equipment</td>
                                              <td>Job Name</td>
                                              <td>Component Name</td>
                                              <td>Frequency</td>
                                              <td>Last Maintenance</td>
                                              <td>Due Date</td>
                                              <td>Current</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="(job, index) in jobs">
                                              <tr :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ job.fleet }}</td>
                                                <td>{{ job.jobName }}</td>
                                                <td>{{ job.componentName }}</td>
                                                <td>{{ job.frequency }}</td>
                                                <td>{{ job.lastMaintenance }}</td>
                                                <td
                                                  ><span>{{ job.dueDate }}</span
                                                  ><div
                                                    v-if="
                                                      job.pendingDate === null ||
                                                      job.pendingDate === '' ||
                                                      job.pendingDate === undefined
                                                    "
                                                  ></div>
                                                  <div v-else
                                                    ><small
                                                      >Last Due #1 :
                                                      {{ job.pendingDate }}</small
                                                    ></div
                                                  ></td
                                                >
                                                <td>{{ job.current }}</td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-tab>

                                    <b-tab title="Next Jobs 6 Month">
                                      <div class="table-responsive">
                                        <table
                                          class="
                                            table
                                            mb-0
                                            table-striped table-hover
                                          "
                                        >
                                          <thead class="text-center">
                                            <tr>
                                              <td>No</td>
                                              <td>Fleet/Equipment</td>
                                              <td>Job Name</td>
                                              <td>Component Name</td>
                                              <td>Frequency</td>
                                              <td>Last Maintenance</td>
                                              <td>Due Date</td>
                                              <td>Current</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="(job, index) in jobs">
                                              <tr :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ job.fleet }}</td>
                                                <td>{{ job.jobName }}</td>
                                                <td>{{ job.componentName }}</td>
                                                <td>{{ job.frequency }}</td>
                                                <td>{{ job.lastMaintenance }}</td>
                                                <td
                                                  ><span>{{ job.dueDate }}</span
                                                  ><div
                                                    v-if="
                                                      job.pendingDate === null ||
                                                      job.pendingDate === '' ||
                                                      job.pendingDate === undefined
                                                    "
                                                  ></div>
                                                  <div v-else
                                                    ><small
                                                      >Last Due #1 :
                                                      {{ job.pendingDate }}</small
                                                    ></div
                                                  ></td
                                                >
                                                <td>{{ job.current }}</td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-tab>

                                    <b-tab title="Next Jobs 12 Month">
                                      <div class="table-responsive">
                                        <table
                                          class="
                                            table
                                            mb-0
                                            table-striped table-hover
                                          "
                                        >
                                          <thead class="text-center">
                                            <tr>
                                              <td>No</td>
                                              <td>Fleet/Equipment</td>
                                              <td>Job Name</td>
                                              <td>Component Name</td>
                                              <td>Frequency</td>
                                              <td>Last Maintenance</td>
                                              <td>Due Date</td>
                                              <td>Current</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="(job, index) in jobs">
                                              <tr :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ job.fleet }}</td>
                                                <td>{{ job.jobName }}</td>
                                                <td>{{ job.componentName }}</td>
                                                <td>{{ job.frequency }}</td>
                                                <td>{{ job.lastMaintenance }}</td>
                                                <td
                                                  ><span>{{ job.dueDate }}</span
                                                  ><div
                                                    v-if="
                                                      job.pendingDate === null ||
                                                      job.pendingDate === '' ||
                                                      job.pendingDate === undefined
                                                    "
                                                  ></div>
                                                  <div v-else
                                                    ><small
                                                      >Last Due #1 :
                                                      {{ job.pendingDate }}</small
                                                    ></div
                                                  ></td
                                                >
                                                <td>{{ job.current }}</td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-tab>
                                  </b-tabs>
                                </template>
                              </iq-card>
                            </b-col>
                            <!-- Detail Job -->
                          </div>
                        </b-tab>
                        <b-tab title="Finished">
                          <b-row>
                            <!-- Total Finished -->
                            <b-col md="4"></b-col>
                            <b-col md="4">
                              <b-card
                                text-variant="white"
                                bg-variant="success"
                                class="iq-mb-3"
                              >
                                <b-card-title class="text-white text-center"
                                  ><h1 class="text-white">60</h1></b-card-title
                                >
                                <blockquote class="blockquote mb-0 text-center">
                                  <p class="font-size-22"
                                    ><strong>Finished</strong></p
                                  >
                                </blockquote>
                              </b-card>
                            </b-col>
                            <b-col md="4"></b-col>
                            <!-- End Total Finished -->
                            <!-- List Finished -->
                            <b-col sm="12">
                              <iq-card class-name="iq-card-block iq-card-stretch">
                                <template v-slot:body>
                                  <div class="table-responsive">
                                    <table
                                      class="table mb-0 table-striped table-hover"
                                      style="width: 2000px"
                                    >
                                      <thead class="text-center">
                                        <tr>
                                          <td>No</td>
                                          <td>Fleet/Equipment</td>
                                          <td>Job Name</td>
                                          <td>Component Name</td>
                                          <td>Frequency</td>
                                          <td>Last Maintenance</td>
                                          <td>Due Date / Hours</td>
                                          <td>Start Date</td>
                                          <td>End Date</td>
                                          <td>Cost</td>
                                          <td>Notes</td>
                                          <td>Port Engineer/PIC</td>
                                          <td>File</td>
                                          <td>Status</td>
                                          <td>Created At</td>
                                          <td>Created by</td>
                                          <td>Approved by</td>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <template
                                          v-for="(job, index) in jobsFinished"
                                        >
                                          <tr :key="index">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ job.fleet }}</td>
                                            <td
                                              ><router-link to="">{{
                                                job.jobName
                                              }}</router-link></td
                                            >
                                            <td>{{ job.componentName }}</td>
                                            <td>{{ job.frequency }}</td>
                                            <td>{{ job.lastMaintenance }}</td>
                                            <td
                                              ><span>{{ job.dueDate }}</span
                                              ><div
                                                v-if="
                                                  job.pendingDate === null ||
                                                  job.pendingDate === '' ||
                                                  job.pendingDate === undefined
                                                "
                                              ></div>
                                              <div v-else
                                                ><small
                                                  >Last Due #1 :
                                                  {{ job.pendingDate }} ({{
                                                    job.reason
                                                  }})</small
                                                ></div
                                              ></td
                                            >
                                            <td>{{ job.start }}</td>
                                            <td
                                              ><span>{{ job.end }} </span
                                              ><span
                                                v-if="job.frequency === '10.000 H'"
                                                >/ {{ job.current }}</span
                                              ></td
                                            >
                                            <td>{{ job.cost }}</td>
                                            <td>{{ job.note }}</td>
                                            <td>{{ job.pic }}</td>
                                            <td>-</td>
                                            <td
                                              ><b-badge variant="success">{{
                                                job.status
                                              }}</b-badge></td
                                            >
                                            <td>{{ job.createdAt }}</td>
                                            <td>{{ job.createdBy }}</td>
                                            <td>{{ job.approvedBy }}</td>
                                          </tr>
                                        </template>
                                      </tbody>
                                    </table>
                                  </div>
                                </template>
                              </iq-card>
                            </b-col>
                            <!-- End List Finished -->
                          </b-row>
                        </b-tab>
                      </b-tabs>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <!-- End Content Section !-->
            </b-tab>

            <b-tab title="Maintenance Initiation">
              <b-row>
                <b-col lg="12">
                  <b-card>
                    <b-card-title>
                      <div class="row">
                        <div class="col-md-10">
                          <h4 class="card-title text-primary"
                            ><strong>Filter Maintenance Initiation</strong></h4
                          >
                        </div>
                        <div class="col-md-2 float-right">
                          <a
                            class="text-primary float-right"
                            v-b-toggle.collapse-filter
                            role="button"
                            style="cursor: pointer"
                          >
                            <i class="fa fa-filter" />
                          </a>
                        </div>
                      </div>
                    </b-card-title>

                    <b-card-body>
                      <b-collapse id="collapse-filter" visible>
                        <b-row>
                          <b-col md="4">
                            <b-form-group label="Category:" label-for="kind-fleet">
                              <template v-for="(item, index) in vehicle">
                                <b-form-checkbox
                                  v-model="item.checked"
                                  :disabled="item.disabled"
                                  name="check-button"
                                  switch
                                  inline
                                  :key="index"
                                >
                                  {{ item.label }}
                                </b-form-checkbox>
                              </template>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-form-group
                              label="Fleet/Equipment:"
                              label-for="fleet-equipment"
                            >
                              <v-multiselect
                                v-model="selectedFleetEquipment"
                                tag-placeholder="Category"
                                placeholder="Search or add a category"
                                label="name"
                                track-by="code"
                                :options="fleetEquipmentList"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                              >
                              </v-multiselect>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-form-group label="Equipment" label-for="equipment">
                              <v-select
                                label="text"
                                v-model="selectedRole"
                                :options="role"
                                :reduce="(role) => role.value"
                              ></v-select>
                            </b-form-group>
                          </b-col>
                          <b-col md="2">
                            <b-form-group label="Filter" label-for="button_search">
                              <b-button variant="primary" class="mb-3 mr-1"
                                ><i class="fa fa-filter"></i
                              ></b-button>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <!-- End Top Section !-->
              <!-- Content Section !-->
              <b-row>
                <b-col lg="12">
                  <b-card>
                    <b-card-title>
                      <div class="row">
                        <div class="col-md-10">
                          <h4 class="card-title text-primary"
                            ><strong>Maintenance Initiation</strong></h4
                          >
                        </div>
                        <div class="col-md-2 float-right">
                          <b-button
                            v-b-modal.add-init
                            variant="success"
                            class="mt-2 mb-3 mr-1"
                            ><i class="fa fa-plus"></i>Maintenance Initiation</b-button
                          >
                          <b-modal
                            id="add-init"
                            size="lg"
                            title="Add Initiation"
                            ok-title="Submit"
                            cancel-title="Close"
                          >
                            <fieldset class="form-group border p-3">
                              <legend class="w-auto px-2">Details:</legend>
                              <b-row>
                                <b-col md="2"></b-col>
                                <b-col md="8">
                                  <b-form-group label="Fleet:" label-for="fleet">
                                    <v-select label="text" :options="fleet"></v-select>
                                  </b-form-group>
                                </b-col>
                                <b-col md="2"></b-col>
                                <b-col md="6">
                                  <b-form-group label="Job Name:" label-for="job_name">
                                    <b-form-input
                                      id="job_name"
                                      type="text"
                                      placeholder="Job Name"
                                    ></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col md="6">
                                  <b-form-group
                                    label="Equipment:"
                                    label-for="equipment"
                                  >
                                    <v-multiselect
                                      v-model="equipmentValue"
                                      :options="equipmentOptions"
                                      :multiple="false"
                                      group-values="sub"
                                      group-label="project"
                                      :group-select="true"
                                      placeholder="Type to search"
                                      track-by="code"
                                      label="name"
                                    >
                                      <span slot="noResult"
                                        >Oops! No elements found. Consider changing the
                                        search query.</span
                                      >
                                    </v-multiselect>
                                  </b-form-group>
                                </b-col>
                                <b-col md="4">
                                  <div><i>Category Equipment</i></div>
                                  <div>Hull & Loadline</div>
                                </b-col>
                                <b-col md="4">
                                  <div><i>Equipment</i></div>
                                  <div>Hull</div>
                                </b-col>
                                <b-col md="4">
                                  <div><i>Brand</i></div>
                                  <div>-</div>
                                </b-col>
                                <b-col md="12">
                                  <div class="mt-3"
                                    ><i>Standard Job Description</i></div
                                  >
                                  <div>- Check zinc anode, replace when necessary</div>
                                </b-col>
                              </b-row>
                            </fieldset>
                            <fieldset class="form-group border p-3">
                              <legend class="w-auto px-2">Triggers:</legend>
                              <b-row>
                                <b-col md="12" class="text-center mb-4">
                                  <template v-for="(item, index) in triggers">
                                    <b-form-radio
                                      v-model="selectedTrigger"
                                      class="custom-radio-color-checked"
                                      inline
                                      :color="item.color"
                                      name="color"
                                      :key="index"
                                      :value="item.value"
                                      :disabled="item.disabled"
                                      >{{ item.label }}</b-form-radio
                                    >
                                  </template>
                                </b-col>
                                <template v-if="selectedTrigger === 'once_time'">
                                  <b-col md="6">
                                    <b-form-group
                                      label="Start Date:"
                                      label-for="startDate"
                                    >
                                      <b-form-input
                                        type="date"
                                        value="2019-12-19"
                                      ></b-form-input>
                                      <small style="float: right"
                                        >click <i class="fa fa-calendar"></i> to
                                        show</small
                                      >
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group label="End Date:" label-for="endDate">
                                      <b-form-input
                                        type="date"
                                        value="2019-12-19"
                                      ></b-form-input>
                                      <small style="float: right"
                                        >click <i class="fa fa-calendar"></i> to
                                        show</small
                                      >
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group label="Cost:" label-for="cost">
                                      <b-input-group size="md" prepend="Rp">
                                        <b-form-input type="number"></b-form-input>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label-for="maintenanceFile"
                                      label="File Maintenance"
                                    >
                                      <b-form-file
                                        placeholder="Choose a file"
                                        id="customFile"
                                      ></b-form-file>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="12">
                                    <b-form-group label-for="Notes" label="Notes">
                                      <b-form-textarea
                                        id="notes"
                                        rows="3"
                                        placeholder="Type Notes"
                                      ></b-form-textarea>
                                    </b-form-group>
                                  </b-col>
                                </template>
                                <template v-if="selectedTrigger === 'calendar_trigger'">
                                  <b-col md="6">
                                    <b-form-group label-for="pattern" label="Pattern">
                                      <template
                                        v-for="(item, index2) in patternCalendar"
                                      >
                                        <b-form-radio
                                          v-model="selectedPatternCalendar"
                                          class="custom-radio-color-checked"
                                          inline
                                          :color="item.color"
                                          name="color2"
                                          :key="index2"
                                          :value="item.value"
                                          :disabled="item.disabled"
                                          >{{ item.label }}</b-form-radio
                                        >
                                      </template>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label="Interval/Frequency:"
                                      label-for="Interval:"
                                    >
                                      <template
                                        v-if="selectedPatternCalendar === 'day'"
                                      >
                                        <b-input-group size="md" append="Days">
                                          <b-form-input type="number"></b-form-input>
                                        </b-input-group>
                                      </template>
                                      <template
                                        v-if="selectedPatternCalendar === 'week'"
                                      >
                                        <b-input-group size="md" append="Weeks">
                                          <b-form-input type="number"></b-form-input>
                                        </b-input-group>
                                      </template>
                                      <template
                                        v-if="selectedPatternCalendar === 'month'"
                                      >
                                        <b-input-group size="md" append="Months">
                                          <b-form-input type="number"></b-form-input>
                                        </b-input-group>
                                      </template>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label="Last Maintenance:"
                                      label-for="lastMaintenance"
                                    >
                                      <b-form-input
                                        type="date"
                                        value="2019-12-19"
                                      ></b-form-input>
                                      <small style="float: right"
                                        >click <i class="fa fa-calendar"></i> to
                                        show</small
                                      >
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label="Next Possible Run:"
                                      label-for="nextMaintenance"
                                    >
                                      <b-form-input
                                        type="date"
                                        value="2019-12-19"
                                      ></b-form-input>
                                      <small style="float: right"
                                        >click <i class="fa fa-calendar"></i> to
                                        show</small
                                      >
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group label="Cost:" label-for="cost">
                                      <b-input-group size="md" prepend="Rp">
                                        <b-form-input type="number"></b-form-input>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label-for="maintenanceFile"
                                      label="File Maintenance"
                                    >
                                      <b-form-file
                                        placeholder="Choose a file"
                                        id="customFile"
                                      ></b-form-file>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="12">
                                    <b-form-group label-for="Notes" label="Notes">
                                      <b-form-textarea
                                        id="notes"
                                        rows="3"
                                        placeholder="Type Notes"
                                      ></b-form-textarea>
                                    </b-form-group>
                                  </b-col>
                                </template>
                                <template v-if="selectedTrigger === 'counter_trigger'">
                                  <b-col md="6">
                                    <b-form-group
                                      label="Interval/Frequency:"
                                      label-for="Interval:"
                                    >
                                      <b-input-group size="md" append="Hours">
                                        <b-form-input type="number"></b-form-input>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group label="Current" label-for="Current:">
                                      <strong><i>23.987 H</i></strong>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label="Last Maintenance Date:"
                                      label-for="lastMaintenance"
                                    >
                                      <b-form-input
                                        type="date"
                                        value="2019-12-19"
                                      ></b-form-input>
                                      <small style="float: right"
                                        >click <i class="fa fa-calendar"></i> to
                                        show</small
                                      >
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label="Last Maintenance Hours:"
                                      label-for="lastMaintenanceHours:"
                                    >
                                      <b-input-group size="md" append="Hours">
                                        <b-form-input type="number"></b-form-input>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label="Next Possible Value:"
                                      label-for="NextMaintenance:"
                                    >
                                      <b-input-group size="md" append="Hours">
                                        <b-form-input type="number"></b-form-input>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group label="Cost:" label-for="cost">
                                      <b-input-group size="md" prepend="Rp">
                                        <b-form-input type="number"></b-form-input>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label-for="maintenanceFile"
                                      label="File Maintenance"
                                    >
                                      <b-form-file
                                        placeholder="Choose a file"
                                        id="customFile"
                                      ></b-form-file>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="12">
                                    <b-form-group label-for="Notes" label="Notes">
                                      <b-form-textarea
                                        id="notes"
                                        rows="3"
                                        placeholder="Type Notes"
                                      ></b-form-textarea>
                                    </b-form-group>
                                  </b-col>
                                </template>
                              </b-row>
                            </fieldset>
                          </b-modal>
                        </div>
                      </div>
                    </b-card-title>
                    
                    <b-card-body>
                      <div class="table-responsive">
                        <table class="table mb-0 table-striped table-hover">
                          <thead class="text-center">
                            <tr>
                              <td>No</td>
                              <td>Fleet/Equipment</td>
                              <td>Job Name</td>
                              <td>Component Name</td>
                              <td>Frequency</td>
                              <td>Job Trigger</td>
                              <td>Last Maintenance</td>
                              <td>Due Date / Hours</td>
                              <td>Status</td>
                              <td>Created At</td>
                              <td>Created by</td>
                              <td>Approved by</td>
                              <td>Action</td>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(job, index) in jobsInit">
                              <tr :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ job.fleet }}</td>
                                <td
                                  ><router-link to="">{{
                                    job.jobName
                                  }}</router-link></td
                                >
                                <td>{{ job.componentName }}</td>
                                <td>{{ job.frequency }}</td>
                                <td
                                  ><strong>{{ job.trigger }}</strong></td
                                >
                                <td>{{ job.lastMaintenance }}</td>
                                <td
                                  ><span>{{ job.dueDate }}</span></td
                                >
                                <td
                                  ><b-badge variant="success">{{
                                    job.status
                                  }}</b-badge></td
                                >
                                <td>{{ job.createdAt }}</td>
                                <td>{{ job.createdBy }}</td>
                                <td>{{ job.approvedBy }}</td>
                                <td>
                                  <b-button
                                    variant="danger"
                                    size="sm"
                                    class="mt-1 mb-1 mr-1"
                                    ><i class="fa fa-trash"></i
                                  ></b-button>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab title="Master Equipment">
              <b-row>
                <b-col lg="12">
                  <b-card>
                    <b-card-title>
                      <div class="row">
                        <div class="col-md-10">
                          <h4 class="card-title text-primary"
                            ><strong>Filter Master Equipment</strong></h4
                          >
                        </div>
                        <div class="col-md-2 float-right">
                          <a
                            class="text-primary float-right"
                            v-b-toggle.collapse-filter
                            role="button"
                            style="cursor: pointer"
                          >
                            <i class="fa fa-filter" />
                          </a>
                        </div>
                      </div>
                    </b-card-title>

                    <b-card-body>
                      <b-collapse id="collapse-filter" visible>
                        <b-row>
                          <b-col md="4">
                            <b-form-group label="Category:" label-for="kind-fleet">
                              <template v-for="(item, index) in vehicle">
                                <b-form-checkbox
                                  v-model="item.checked"
                                  :disabled="item.disabled"
                                  name="check-button"
                                  switch
                                  inline
                                  :key="index"
                                >
                                  {{ item.label }}
                                </b-form-checkbox>
                              </template>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-form-group
                              label="Fleet/Equipment:"
                              label-for="fleet-equipment"
                            >
                              <b-form-input
                                type="text"
                                id="fleet_name"
                                placeholder="Type Master Equipment"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col md="2">
                            <b-form-group label="Filter" label-for="button_search">
                              <b-button variant="primary" class="mb-3 mr-1"
                                ><i class="fa fa-filter"></i
                              ></b-button>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <!-- End Top Section !-->
              <!-- Content Section !-->
              <b-row>
                <b-col lg="12">
                  <b-card>
                    <b-card-title>
                      <div class="row">
                        <div class="col-md-10">
                          <h4 class="card-title text-primary"
                            ><strong>Master Equipment</strong></h4
                          >
                        </div>
                        <div class="col-md-2 float-right">
                          <b-button
                            v-b-modal.add-master
                            variant="success"
                            class="mt-2 mb-3 mr-1"
                            ><i class="fa fa-plus"></i>Master Equipment</b-button
                          >
                          <b-modal
                            id="add-master"
                            size="lg"
                            title="Add Master Equipment"
                            ok-title="Submit"
                            cancel-title="Close"
                          >
                            <b-row>
                              <b-col md="12" class="text-center mb-4">
                                <template v-for="(item, index) in typeEquipment">
                                  <b-form-radio
                                    v-model="selectedTypeEquipment"
                                    class="custom-radio-color-checked"
                                    inline
                                    :color="item.color"
                                    name="color"
                                    :key="index"
                                    :value="item.value"
                                    :disabled="item.disabled"
                                    >{{ item.label }}</b-form-radio
                                  >
                                </template>
                              </b-col>
                              <b-col md="12">
                                <b-form-group
                                  label="Category Equipment"
                                  label-for="category_equipment"
                                >
                                  <b-row>
                                    <b-col md="8">
                                      <v-select
                                        label="text"
                                        :options="category"
                                      ></v-select>
                                    </b-col>
                                    <b-col md="4">
                                      <a
                                        href=""
                                        @click.prevent="showAddCategory"
                                        v-if="!show_add_category"
                                        >Add Category</a
                                      >
                                      <a href="" @click.prevent="hideAddCategory" v-else
                                        >Cancel</a
                                      >
                                    </b-col>
                                  </b-row>
                                </b-form-group>
                              </b-col>
                              <b-col
                                md="12"
                                v-if="show_add_category"
                                class="mt-3 bg-light"
                              >
                                <b-row>
                                  <b-col md="4">
                                    <b-form-group
                                      label="Category No"
                                      label-for="component_no"
                                    >
                                      <b-form-input type="number"></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-form-group
                                      label="Category Name"
                                      label-for="component_name"
                                    >
                                      <b-form-input type="text"></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="2">
                                    <b-form-group
                                      label="Save"
                                      label-for="component_name"
                                    >
                                      <b-button variant="primary" class="mb-3 mr-1"
                                        ><i class="fa fa-save"></i
                                      ></b-button>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <fieldset class="form-group border p-3">
                              <legend class="w-auto px-2">Details:</legend>
                              <b-row>
                                <b-col md="6">
                                  <b-form-group
                                    label="Component No"
                                    label-for="component_no"
                                  >
                                    <b-form-input type="number"></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col md="6">
                                  <b-form-group
                                    label="Component Name"
                                    label-for="component_name"
                                  >
                                    <b-form-input type="text"></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col md="6">
                                  <b-form-group
                                    label="Type No"
                                    label-for="component_no"
                                  >
                                    <b-form-input type="number"></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col md="6">
                                  <b-form-group
                                    label="Serial No"
                                    label-for="component_no"
                                  >
                                    <b-form-input type="number"></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col md="6">
                                  <b-form-group
                                    label="Drawing No"
                                    label-for="component_no"
                                  >
                                    <b-form-input type="number"></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col md="6">
                                  <b-form-group
                                    label="Classification"
                                    label-for="component_no"
                                  >
                                    <b-form-input type="text"></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col md="12">
                                  <b-form-group
                                    label-for="Standard Job Description"
                                    label="Notes"
                                  >
                                    <b-form-textarea
                                      id="notes"
                                      rows="3"
                                      placeholder="Type Standard Job"
                                    ></b-form-textarea>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </fieldset>
                            <fieldset
                              class="form-group border p-3"
                              v-if="selectedTypeEquipment === 'machinery'"
                            >
                              <legend class="w-auto px-2">Machinery Options:</legend>
                              <b-row>
                                <b-col md="6">
                                  <b-form-group
                                    label="Type of Machine"
                                    label-for="type_machine"
                                  >
                                    <template v-for="(item, index) in typeOfMachine">
                                      <b-form-radio
                                        v-model="selectedTypeOfMachine"
                                        class="custom-radio-color-checked"
                                        inline
                                        :color="item.color"
                                        name="typeOfMachine"
                                        :key="index"
                                        :value="item.value"
                                        :disabled="item.disabled"
                                        >{{ item.label }}</b-form-radio
                                      >
                                    </template>
                                  </b-form-group>
                                </b-col>
                                <b-col md="6">
                                  <b-form-group
                                    label="Position of Machine"
                                    label-for="noOfMachine"
                                  >
                                    <template v-for="(item, index) in noOfMachine">
                                      <b-form-radio
                                        v-model="selectedNoOfMachine"
                                        class="custom-radio-color-checked"
                                        inline
                                        :color="item.color"
                                        name="nofMachine"
                                        :key="index"
                                        :value="item.value"
                                        :disabled="item.disabled"
                                        >{{ item.label }}</b-form-radio
                                      >
                                    </template>
                                  </b-form-group>
                                </b-col>
                                <b-col md="12">
                                  <b-form-group
                                    label="Manufacturer / Brand"
                                    label-for="category_equipment"
                                  >
                                    <b-row>
                                      <b-col md="8">
                                        <v-select
                                          label="text"
                                          :options="manufacturer"
                                          v-model="selectedManufacturer"
                                          :reduce="(manufacturer) => manufacturer.value"
                                        ></v-select>
                                      </b-col>
                                      <b-col md="4">
                                        <a
                                          href=""
                                          @click.prevent="showAddManufacturer"
                                          v-if="!show_add_manufacturer"
                                          >Add Manufacturer</a
                                        >
                                        <a
                                          href=""
                                          @click.prevent="hideAddManufacturer"
                                          v-else
                                          >Cancel</a
                                        >
                                      </b-col>
                                    </b-row>
                                  </b-form-group>
                                </b-col>
                                <b-col
                                  md="12"
                                  v-if="show_add_manufacturer"
                                  class="mt-3 bg-light"
                                >
                                  <b-row>
                                    <b-col md="8">
                                      <b-form-group
                                        label="Manufacturer Name"
                                        label-for="manufacturer_name"
                                      >
                                        <b-form-input type="text"></b-form-input>
                                      </b-form-group>
                                    </b-col>
                                    <b-col md="2">
                                      <b-form-group
                                        label="Save"
                                        label-for="component_name"
                                      >
                                        <b-button variant="primary" class="mb-3 mr-1"
                                          ><i class="fa fa-save"></i
                                        ></b-button>
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </fieldset>
                          </b-modal>
                        </div>
                      </div>
                    </b-card-title>
                    <b-card-body>
                      <div class="table-responsive">
                        <table class="table mb-0 table-striped table-hover">
                          <thead class="text-center">
                            <tr>
                              <td>No</td>
                              <td>Type</td>
                              <td>Category Equipment</td>
                              <td>Component No</td>
                              <td>Component Name</td>
                              <td>Type No</td>
                              <td>Manufacturer / Brand</td>
                              <td>Position</td>
                              <td>Action</td>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(master, index) in masterEquipment">
                              <tr :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ master.type }}</td>
                                <td>{{ master.category }}</td>
                                <td>{{ master.componentNo }}</td>
                                <td>{{ master.componentName }}</td>
                                <td>{{ master.typeNo }}</td>
                                <td>{{ master.manufacturer }}</td>
                                <td>{{ master.position }}</td>
                                <td>
                                  <b-button
                                    variant="success"
                                    size="sm"
                                    class="mt-1 mb-1 mr-1"
                                    ><i class="fa fa-edit"></i
                                  ></b-button>
                                  <b-button
                                    variant="danger"
                                    size="sm"
                                    class="mt-1 mb-1 mr-1"
                                    ><i class="fa fa-trash"></i
                                  ></b-button>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab title="Running Hours Data">
              <b-row>
                <b-col lg="12">
                  <b-card>
                    <b-card-title>
                      <div class="row">
                        <div class="col-md-10">
                          <h4 class="card-title text-primary"
                            ><strong>Filter Running Hours Data</strong></h4
                          >
                        </div>
                        <div class="col-md-2 float-right">
                          <a
                            class="text-primary float-right"
                            v-b-toggle.collapse-filter
                            role="button"
                            style="cursor: pointer"
                          >
                            <i class="fa fa-filter" />
                          </a>
                        </div>
                      </div>
                    </b-card-title>
                    <b-card-body>
                      <b-collapse id="collapse-filter" visible>
                        <b-row>
                          <b-col md="4">
                            <b-form-group label="Category:" label-for="kind-fleet">
                              <template v-for="(item, index) in vehicle">
                                <b-form-checkbox
                                  v-model="item.checked"
                                  :disabled="item.disabled"
                                  name="check-button"
                                  switch
                                  inline
                                  :key="index"
                                >
                                  {{ item.label }}
                                </b-form-checkbox>
                              </template>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-form-group
                              label="Fleet/Equipment:"
                              label-for="fleet-equipment"
                            >
                              <v-multiselect
                                v-model="selectedFleetEquipment"
                                tag-placeholder="Category"
                                placeholder="Search or add a category"
                                label="name"
                                track-by="code"
                                :options="fleetEquipmentList"
                                :multiple="false"
                                :taggable="false"
                                @tag="addTag"
                              >
                              </v-multiselect>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-form-group
                              label="Date Range:"
                              label-for="Date Range"
                            >
                              <date-picker
                                :lang="lang"
                                v-model="dateRange"
                                type="date"
                                range
                                placeholder="Select date range"
                              ></date-picker>
                            </b-form-group>
                          </b-col>
                          <b-col md="2">
                            <b-form-group label="Filter" label-for="button_search">
                              <b-button variant="primary" class="mb-3 mr-1"
                                ><i class="fa fa-filter"></i
                              ></b-button>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <!-- End Top Section !-->
              <!-- Content Section !-->
              <b-row>
                <b-col lg="12">
                  <b-card>
                    <b-card-title>
                      <div class="row">
                        <div class="col-md-10">
                          <h4 class="card-title text-primary"
                            ><strong>Running Hours Data</strong></h4
                          >
                        </div>
                        <div class="col-md-2 float-right">
                          <b-button
                            v-b-modal.add-runningHours
                            variant="success"
                            class="mt-2 mb-3 mr-1"
                            ><i class="fa fa-plus"></i>Running Hours Data</b-button
                          >
                          <b-modal
                            id="add-runningHours"
                            size="lg"
                            title="Add Running Hours Data"
                            ok-title="Submit"
                            cancel-title="Close"
                          >
                            <b-row>
                              <b-col md="2"></b-col>
                              <b-col md="8">
                                <b-form-group label="Fleet:" label-for="fleet">
                                  <v-select label="text" :options="fleet"></v-select>
                                </b-form-group>
                              </b-col>
                              <b-col md="2"></b-col>
                              <b-col md="2"></b-col>
                              <b-col md="8">
                                <b-form-group label="Date:" label-for="date">
                                  <b-form-input
                                    type="date"
                                    value="2019-12-19"
                                  ></b-form-input>
                                  <small style="float: right"
                                    >click <i class="fa fa-calendar"></i> to show</small
                                  >
                                </b-form-group>
                              </b-col>
                              <b-col md="2"></b-col>
                              <b-col md="6">
                                <b-form-group label="AE 1" label-for="ae1:">
                                  <b-input-group size="md" append="Hours">
                                    <b-form-input type="number"></b-form-input>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col md="6">
                                <b-form-group label="AE 2" label-for="ae2:">
                                  <b-input-group size="md" append="Hours">
                                    <b-form-input type="number"></b-form-input>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col md="6">
                                <b-form-group label="ME 1" label-for="me1:">
                                  <b-input-group size="md" append="Hours">
                                    <b-form-input type="number"></b-form-input>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col md="6">
                                <b-form-group label="ME 2" label-for="me2:">
                                  <b-input-group size="md" append="Hours">
                                    <b-form-input type="number"></b-form-input>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-modal>
                        </div>
                      </div>
                    </b-card-title>
                    <b-card-body>
                      <div class="table-responsive">
                        <table class="table mb-0 table-striped table-hover">
                          <thead class="text-center thead-dark">
                            <tr>
                              <th rowspan="2" class="text-center">No</th>
                              <th rowspan="2">Fleet / Equipment</th>
                              <th rowspan="2">Date</th>
                              <th colspan="4">Running Hours</th>
                              <th rowspan="2">Action</th>
                            </tr>
                            <tr>
                              <th>AE1</th>
                              <th>AE2</th>
                              <th>ME1</th>
                              <th>ME2</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>TB.ETI 101</td>
                              <td>10 Juni 2021</td>
                              <td>12 H</td>
                              <td>8 H</td>
                              <td>10 H</td>
                              <td>12 H</td>
                              <td>
                                <b-button
                                  variant="success"
                                  size="sm"
                                  class="mt-1 mb-1 mr-1"
                                  ><i class="fa fa-edit"></i
                                ></b-button>
                                <b-button
                                  variant="danger"
                                  size="sm"
                                  class="mt-1 mb-1 mr-1"
                                  ><i class="fa fa-trash"></i
                                ></b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {
  name: 'MaintenanceSummary',
  page: {
    title: 'Starter',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      dateRange: '',
      show_add_category: false,
      show_add_manufacturer: false,
      selectedBarge: null,
      selectedDischarge: null,
      selectedDestination: null,
      selectedCategoryOwnership: 'all',
      categoryOwnership: [
        { value: 'all', text: 'All Category Ownership' },
        { value: 'owned', text: 'Owned By Company' },
        { value: 'chartered', text: 'Chartered' },
      ],
      selectedRole: '1',
      fleet: [
        { value: '1', text: 'TB.TCP-202' },
        { value: '2', text: 'BG.SML-105' },
        { value: '3', text: 'BG.ETI-201' },
      ],
      role: [
        { value: '1', text: 'Luffing Pump' },
        { value: '2', text: 'Hull' },
        { value: '3', text: 'Load Line' },
        { value: '4', text: 'Basic Engine' },
        { value: '5', text: 'Fuel Oil (Tank)' },
        { value: '6', text: 'Lubrication Oil Tank' },
        { value: '7', text: 'Ballast Tank' },
        { value: '8', text: 'Void Tank' },
        { value: '9', text: 'Chain Locker' },
      ],
      vehicle: [
        {
          label: 'Tug Boat',
          checked: true,
          disabled: false,
        },
        {
          label: 'Barge',
          checked: true,
          disabled: false,
        },
        {
          label: 'Pusher Tug',
          checked: false,
          disabled: false,
        },
        {
          label: 'Pusher Barge',
          checked: false,
          disabled: false,
        },
        {
          label: 'Mother Vessel',
          checked: true,
          disabled: false,
        },
        {
          label: 'Floating Crane',
          checked: true,
          disabled: false,
        },
        {
          label: 'Heavy Equipment',
          checked: true,
          disabled: false,
        },
      ],
      barge: [
        { value: '1', text: 'BG.TCP-202' },
        { value: '2', text: 'BG.SML-105' },
        { value: '3', text: 'BG.ETI-201' },
      ],
      discharge: [
        { value: '1', text: 'Asam-Asam' },
        { value: '2', text: 'Tanjung Awar-awar' },
        { value: '3', text: 'Kintap' },
      ],
      destination: [
        { value: '1', text: 'Asam-Asam' },
        { value: '2', text: 'Tanjung Awar-awar' },
        { value: '3', text: 'Kintap' },
      ],
      status_fleet: [
        { value: '1', text: 'All' },
        { value: '2', text: 'Mine Fleet' },
        { value: '3', text: 'Rent Fleet' },
      ],
      docking: [
        { value: '1', text: 'All' },
        { value: '2', text: 'Special Survey' },
        { value: '3', text: 'Intermediate Survey' },
      ],
      selectedFleetEquipment: [
        { name: 'TB.ETI 201', code: 'tb' },
        { name: 'TB.TCP 301', code: 'bg' },
        { name: 'TB.Navareno 1', code: 'pusher_tug' },
        { name: 'HE.ETI 30D', code: 'pusher_barge' },
      ],
      fleetEquipmentList: [
        {
          name: 'TB.ETI 201',
          code: 'tb',
        },
        {
          name: 'TB.TCP 301',
          code: 'bg',
        },
        {
          name: 'TB.Navareno 1',
          code: 'pusher_tug',
        },
        {
          name: 'HE.ETI 30D',
          code: 'pusher_barge',
        },
        {
          name: 'BG.SML 111',
          code: 'mv',
        },
        {
          name: 'BG.ETI 202',
          code: 'fc',
        },
        {
          name: 'BG.TCP 302',
          code: 'he',
        },
      ],
      jobs: [
        {
          fleet: 'TB.ETI 201',
          jobName: '10.000 H Maintenance Job',
          componentNo: '813001',
          componentName: 'Fire Pump',
          current: '23.200 H',
          frequency: '10.000 H',
          lastMaintenance: '13 Januari 2021 / 11.000 H',
          pendingDate: '21.000 H',
          dueDate: '23.000 H',
          reason: 'Still Sailing',
          status: 'Over 200 H',
        },
        {
          fleet: 'TB.TCP 101',
          jobName: 'Oil Cooler Change',
          componentNo: '43204',
          componentName: 'Hydraulic Pump Units FWD Port',
          current: '25 Maret 2021',
          frequency: '3 Month',
          lastMaintenance: '5 Oktober 2020',
          pendingDate: '5 Januari 2021',
          dueDate: '20 Maret 2021',
          reason: 'Nanti aja belum ada budgetnya',
          status: 'Over 5 Days',
        },
      ],
      jobsHours: [
        {
          fleet: 'TB.ETI 201',
          jobName: '10.000 H Maintenance Job',
          componentName: 'Fire Pump',
          current: '21.200 H',
          frequency: '10.000 H',
          lastMaintenance: '13 Januari 2021 / 11.000 H',
          lastRunningMaintenance: '10.100 H',
          nextRunningHours: '23.000 H',
          status: '2.000 H Left',
        },
        {
          fleet: 'TB.TCP 101',
          jobName: '12.000 H Maintenance',
          componentName: 'A/c',
          current: '20.500 H',
          frequency: '12.000 H',
          lastMaintenance: '5 Oktober 2020',
          lastRunningMaintenance: '12.100 H',
          nextRunningHours: '25.000 H',
          status: '4.500 H Left',
        },
      ],
      jobsFinished: [
        {
          fleet: 'TB.ETI 201',
          jobName: '10.000 H Maintenance Job',
          componentName: 'Fire Pump',
          current: '23.200 H',
          frequency: '10.000 H',
          lastMaintenance: '13 Januari 2021 / 11.000 H',
          pendingDate: '21.000 H',
          dueDate: '23.000 H',
          start: '14 Maret 2021',
          end: '16 Maret 2021',
          cost: 0,
          note: 'Maintenance Berhasil',
          pic: 'Bash Uum',
          createdAt: '21 Maret 2021',
          createdBy: 'Fitri',
          approvedBy: 'Frans Mangatur',
          reason: 'Still Sailing',
          status: 'finished maintenance',
        },
        {
          fleet: 'TB.Navareno 1',
          jobName: '12.000 H Maintenance Job',
          componentName: 'A/c',
          current: '23.200 H',
          frequency: '10.000 H',
          lastMaintenance: '13 Januari 2021 / 11.000 H',
          pendingDate: '21.000 H',
          dueDate: '23.000 H',
          start: '14 Maret 2021',
          end: '16 Maret 2021',
          cost: 0,
          note: 'Finish Service Repair',
          pic: 'Bash Uum',
          createdAt: '21 Maret 2021',
          createdBy: 'Fitri',
          approvedBy: 'Frans Mangatur',
          reason: 'Still Sailing',
          status: 'Convert SR - finished',
        },
      ],
      jobsInit: [
        {
          fleet: 'TB.ETI 201',
          jobName: '10.000 H Maintenance Job',
          componentName: 'Fire Pump',
          current: '23.200 H',
          frequency: '10.000 H',
          trigger: 'Once Trigger',
          lastMaintenance: '13 Januari 2021 / 11.000 H',
          dueDate: '23.000 H',
          start: '14 Maret 2021',
          end: '16 Maret 2021',
          cost: 0,
          note: 'Maintenance Berhasil',
          pic: 'Bash Uum',
          createdAt: '21 Maret 2021',
          createdBy: 'Fitri',
          approvedBy: 'Frans Mangatur',
          reason: 'Still Sailing',
          status: 'Finished',
        },
        {
          fleet: 'TB.ETI 201',
          jobName: '17.000 H Maintenance Basic Engine - General Engine',
          componentName: 'Basic Engine - General Engine',
          current: '23.200 H',
          frequency: '17.000 H',
          trigger: 'Counter Trigger',
          lastMaintenance: '13 Januari 2021 / 11.000 H',
          dueDate: '23.000 H',
          start: '14 Maret 2021',
          end: '16 Maret 2021',
          cost: 0,
          note: 'Maintenance Berhasil',
          pic: 'Bash Uum',
          createdAt: '21 Maret 2021',
          createdBy: 'Fitri',
          approvedBy: 'Frans Mangatur',
          reason: 'Still Sailing',
          status: 'Already Run',
        },
        {
          fleet: 'TB.ETI 201',
          jobName: 'Inspection - Lifebouy with Line',
          componentName: 'Lifebouy with Line',
          current: '20 Juni 2021',
          frequency: '1 Month',
          trigger: 'Calendar Trigger',
          lastMaintenance: '13 Juni 2021',
          dueDate: '13 Juli 2021',
          start: '11 Juni 2021',
          end: '12 Juni 2021',
          cost: 0,
          note: 'Maintenance Berhasil',
          pic: 'Bash Uum',
          createdAt: '21 Maret 2021',
          createdBy: 'Fitri',
          approvedBy: 'Frans Mangatur',
          reason: 'Still Sailing',
          status: 'Waiting Next Schedule',
        },
      ],
      equipmentOptions: [
        {
          project: 'Accomodation',
          sub: [
            { code: 'wh', name: 'Wheel House' },
            { code: 'er', name: 'Engine Room' },
            { code: 'ar', name: 'Accomodation Room' },
          ],
        },
        {
          project: 'Hull & Load Line',
          sub: [
            { code: 'hull', name: 'Hull' },
            { code: 'load', name: 'Load Line' },
          ],
        },
        {
          project: 'Tanks',
          sub: [
            { code: 'basic', name: 'Basic Engine' },
            { code: 'lub', name: 'Lubrication Oil Tanks' },
          ],
        },
        {
          project: 'Main Engine',
          sub: [
            {
              code: 'basic',
              name: 'Yanmar 12LAK - Basic Engine - General Engine',
            },
            { code: 'zinc', name: 'Yanmar 12LAK - Zinc Anode (Hoses Clamps)' },
          ],
        },
      ],
      equipmentValue: '',
      selectedTrigger: 'once_time',
      triggers: [
        {
          label: 'Run Once Time',
          color: 'success',
          value: 'once_time',
        },
        {
          label: 'Calendar Trigger',
          color: 'warning',
          value: 'calendar_trigger',
        },
        {
          label: 'Counter Trigger',
          color: 'primary',
          value: 'counter_trigger',
        },
      ],
      selectedPatternCalendar: 'month',
      patternCalendar: [
        {
          label: 'Day',
          color: 'success',
          value: 'day',
        },
        {
          label: 'Week',
          color: 'warning',
          value: 'week',
        },
        {
          label: 'Month',
          color: 'primary',
          value: 'month',
        },
      ],
      masterEquipment: [
        {
          type: 'Non Machinery Equipment',
          category: '3001 - Hull & Load Line',
          componentNo: '30010001',
          componentName: 'Hull',
          typeNo: 'D2 x BW 20/20',
          manufacturer: '-',
          position: '-',
        },
        {
          type: 'Machinery Equipment',
          category: '201 - Main Engine',
          componentNo: '2018764',
          componentName: 'Basic Engine - V-Belt',
          typeNo: '12LAK',
          manufacturer: 'Yanmar 12LAK-STE2',
          position: 'ME - Position No.1',
        },
      ],
      selectedTypeEquipment: 'non',
      typeEquipment: [
        {
          label: 'Non Machinery Equipment',
          color: 'success',
          value: 'non',
        },
        {
          label: 'Machinery Equipment',
          color: 'primary',
          value: 'machinery',
        },
      ],
      category: [
        { value: '1', text: 'Hull & Load Line' },
        { value: '2', text: 'Tanks' },
        { value: '3', text: 'Main Engine' },
      ],
      selectedTypeOfMachine: 'me',
      typeOfMachine: [
        {
          label: 'Mechanical Engine',
          color: 'success',
          value: 'me',
        },
        {
          label: 'Auxiliary Engine',
          color: 'primary',
          value: 'machinery',
        },
      ],
      selectedNoOfMachine: 'no1',
      noOfMachine: [
        {
          label: 'No. 1',
          color: 'success',
          value: 'no1',
        },
        {
          label: 'No. 2',
          color: 'primary',
          value: 'no2',
        },
      ],
      selectedManufacturer: '1',
      manufacturer: [
        { value: '1', text: 'Yanmar 12LAK' },
        { value: '2', text: 'Weichai' },
        { value: '3', text: 'Mitsubishi' },
      ],
      // Breadcrumb
      breadcrumIcon: [
        {
          html: '<i class="ri-home-4-line mr-1 float-left"></i>PMS',
          href: '#',
          active: true,
        },
      ],
    }
  },
  methods: {
    showAddCategory() {
      this.show_add_category = true
    },
    hideAddCategory() {
      this.show_add_category = false
    },
    showAddManufacturer() {
      this.show_add_manufacturer = true
    },
    hideAddManufacturer() {
      this.show_add_manufacturer = false
    },
  },
}
</script>

<style scoped>
</style>
